import { render, staticRenderFns } from "./ItemReserve.vue?vue&type=template&id=80a154f8&"
import script from "./ItemReserve.vue?vue&type=script&lang=js&"
export * from "./ItemReserve.vue?vue&type=script&lang=js&"
import style0 from "./ItemReserve.vue?vue&type=style&index=0&id=80a154f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports